import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { useContext, useState } from "react";
import { Popover, Table } from "antd";
import { EducacionFormal } from "../../../../models/JuradosModel/jurados.model";
import { ModalEducacionFormal } from "./modal-educacionformal.view";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { ModalEliminarExperiencia } from "./ModalEliminarExperiencia";
import { TemplateContext } from "../../../../utils/template_context";

type TableEducacionFormalProps = {
  eduacionFormalArray: EducacionFormal[];
  setEduacionFormalArray: Function;
};

export const TableEducacionFormal = ({
  eduacionFormalArray,
  setEduacionFormalArray,
}: TableEducacionFormalProps) => {
  const context = useContext(TemplateContext);
  const columns: any = [
    {
      title: "No.",
      key: "index",
      fixed: context.device === "md" ? "left" : false,
      width: 60,
      render: (datos: EducacionFormal, record: any, index: number) => (
        <div>{index + 1}</div>
      ),
    },
    {
      title: "Título",
      key: "titulo",
      fixed: context.device === "md" ? "left" : false,
      dataIndex: "titulo",
      render: (datos: any) => {
        return datos?.length > 27 ? (
          <Popover content={datos} title="Título">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${datos.substring(0, 24)}...`}</span>
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Nivel de educación",
      key: "nivel_educacion",
      dataIndex: "nivel_educacion",
      width: 150,
    },
    {
      title: "Institución educativa",
      key: "institucion_educativa",
      dataIndex: "institucion_educativa",
      render: (datos: any) => {
        return datos?.length > 27 ? (
          <Popover content={datos} title="Institución educativa">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${datos.substring(0, 24)}...`}</span>
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Ciudad",
      key: "ciudad",
      dataIndex: "ciudad",
      render: (datos: any) => {
        return datos.length > 27 ? (
          <Popover content={datos} title="Ciudad">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${datos.substring(0, 24)}...`}</span>
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Fecha graduación",
      key: "fecha_graduacion",
      width: 150,
      render: (datos: EducacionFormal, record: any, index: number) => (
        <>{datos.graduado ? `${datos.fecha_graduacion}` : "N/A"}</>
      ),
    },
    {
      title: "Anexo",
      key: "anexo",
      dataIndex: "path_anexo",
      render: (datos: any) => {
        return datos ? (
          datos.length > 27 ? (
            <Popover content={datos} title="Anexo">
              <span
                style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
              >{`${datos.substring(0, 24)}...`}</span>
            </Popover>
          ) : (
            datos
          )
        ) : (
          "N/A"
        );
      },
    },
    {
      title: (
        <div>
          <div className="titleAcciones">Acciones</div>
          <div className="controls pt-1">
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Ver
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Editar
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Borrar
            </div>
          </div>
        </div>
      ),
      key: "actions",
      width: 150,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: EducacionFormal, record: any, index: number) => (
        <div className="controls">
          <EyeOutlined
            onClick={() => {
              console.log(datos);
              if (datos.path_anexo !== "") {
                setDocumentoVisualizar(datos.path_anexo);
                setModalDocumento(true);
              }
            }}
          />
          <EditOutlined onClick={() => showModal(datos, index)} />
          <DeleteOutlined
            className="color-delete"
            onClick={() => {
              console.log(datos);
              setIndexExperiencia(index);
              setTitulo(datos.titulo);
              return setModaleliminar(true);
            }}
          />
        </div>
      ),
    },
  ];

  const deleteEduacion = (datos: any, index: any) => {
    let newArray = eduacionFormalArray.filter(
      (x: any, idx: number) => idx !== index
    );
    setEduacionFormalArray(newArray);
  };

  const eliminarFila = (indexdoc: number) => {
    let infoupdate = [...eduacionFormalArray];
    infoupdate = infoupdate.filter((data: any, i: number) => i !== indexdoc);
    setEduacionFormalArray(infoupdate);
    return setModaleliminar(false);
  };

  const [openModal, setOpenModal] = useState(false);

  const [datosSelected, setDatosSelected] =
    useState<EducacionFormal>(initialValues);
  const [indexDatosSelected, setIndexDatosSelected] = useState(0);
  const [indexExperiencia, setIndexExperiencia] = useState(0);
  const [modaleliminar, setModaleliminar] = useState(false);
  const [titulo, setTitulo] = useState("");

  const showModal = (datos: EducacionFormal, index: number) => {
    setOpenModal(true);
    setDatosSelected(datos);
    setIndexDatosSelected(index);
  };

  const [modalDocumento, setModalDocumento] = useState(false);
  const [documentoVisualizar, setDocumentoVisualizar] = useState("");

  return (
    <>
      <Table
        columns={columns}
        pagination={false}
        dataSource={eduacionFormalArray}
        scroll={{ x: 1500, y: 300 }}
      />

      <ModalVisualizarDocumentos
        state={{ documento: documentoVisualizar }}
        visualizar={modalDocumento}
        setVisualizar={setModalDocumento}
        tipo="participante"
      />

      <ModalEducacionFormal
        openModal={openModal}
        setOpenModal={setOpenModal}
        datosSelected={datosSelected}
        setDatosSelected={setDatosSelected}
        eduacionFormalArray={eduacionFormalArray}
        indexDatosSelected={indexDatosSelected}
        setEduacionFormalArray={setEduacionFormalArray}
      />

      <ModalEliminarExperiencia
        modal={modaleliminar}
        nombre={titulo}
        eliminar={() => eliminarFila(indexExperiencia)}
        cancelar={() => setModaleliminar(false)}
      />
    </>
  );
};

const initialValues = {
  nivel_educacion: "",
  titulo: "",
  institucion_educativa: "",
  ciudad: "",
  graduado: true,
  fecha_graduacion: "",
  path_anexo: "",
};
